<!--
 * @Author: Src
 * @Date: 2024-12-17 10:40:22
 * @LastEditTime: 2025-07-02 10:00:11
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/login/indexLogin.vue
 * @Description: 头部注释配置模板
-->
<template>
	<div class="login">
		<div class="login-title">
			<span @click="login">登录</span>
		</div>
		<div class="login-content">
			<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleRefForm" label-width="100px"
				class="demo-ruleForm">
				<el-form-item prop="phone" label-width="0px">
					<el-input type="number" v-model="ruleForm.phone" placeholder="请输入手机号" @input="picker">
						<template slot="prepend"><i class="el-icon-s-custom"></i></template>
					</el-input>
				</el-form-item>
				<el-form-item prop="checkPass" label-width="0px">
					<div class="code-box">
						<el-input v-model="ruleForm.checkPass" placeholder="请输入图文验证码"></el-input>
						<img :src="img" height="45px" width="100px" v-if="img" @click="changeImg" />
					</div>
				</el-form-item>
				<el-form-item prop="code" label-width="0px">
					<div class="code-box">
						<el-input type="code" v-model="ruleForm.code" placeholder="请输入手机验证码" autocomplete="off">
							<template slot="prepend"><i class="el-icon-chat-dot-round"></i></template>
						</el-input>
						<el-button type="primary" @click="sendCode" :disabled="isRequesting">{{ getAuthCodeTxt }}</el-button>
					</div>
				</el-form-item>
				<el-form-item>
					<!-- <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button> -->
					<!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
				</el-form-item>
			</el-form>
			<el-button type="primary" @click="submitForm" class="login-btn">登录</el-button>
		</div>


	</div>
</template>
<script lang="ts">
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import lazyInject from '@/di';
import AuthService, { Auth, AuthType } from '@/services/auth.service';
import ShopService from '@/services/shop.service';

@Component({})
export default class indexLogin extends Vue {

	@lazyInject(AuthService)
	authService!: AuthService;

	@lazyInject(ShopService)
	shopService!: ShopService;

	@Ref('ruleRefForm')
	ruleRefForm!: HTMLFormElement;

	ruleForm = {
		phone: '',
		checkPass: '',
		code: '',

	};
	isCountingDown = false;

	getAuthCodeTxt = '发送验证码';

	hasSent = false;

	rules = {
		code: [{ required: true, message: '请输入手机验证码', trigger: 'blur' }],
		phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
		checkPass: [{ required: true, message: '请输入图文验证码', trigger: 'blur' }]
	};

	isRequesting = false;

	img = '';

	auth: Auth = new Auth();

	captcha = '';

	@Watch('ruleForm.phone', { immediate: true })
	watchPhone() {
		this.auth.phone = this.ruleForm.phone;
		this.updateSendable();
	}

	updateSendable() {
		this.hasSent = this.testPhoneValid();
	}
	testPhoneValid(): boolean {
		return /1[3-9]\d{9}/.test(this.ruleForm.phone);
	}

	async picker(e: any) {
		if (e.length == 11) {
			// this.$refs.picker?.open();
			const result = await this.authService.captcha(e);
			this.img = result.img;
			this.auth.captchaKey = result.key;
		}
	}
	async sendCode() {
		if (this.isRequesting) {
			this.isRequesting = false
		}
		await this.sendAuthCode();

	}
	changeImg() {
		this.picker(this.ruleForm.phone);
	}
	/** 发送验证码 */

	async sendAuthCode(): Promise<void> {
		if (!this.testPhoneValid()) {
			this.$message.error('手机格式不正确，请重新输入哦~');
			return;
		}
		if (!this.ruleForm.checkPass) {
			this.$message.error('请输入图文验证码');
			return;
		}
		const { checkPass } = this.ruleForm;
		this.auth.captcha = checkPass;

		this.hasSent = true;
		this.auth.type = AuthType.VERIFICATION_CODE;
		try {
			if (this.isRequesting) return;
			this.isRequesting = true;

			const result = await this.authService.sendAuth(this.auth);
			if (result === 'OK') {
				this.$message.success('验证码已发送');
				this.countdown(60);
			}
		} catch (error) {
			this.$message.error(`${error}`);
			this.isRequesting = false;
		}
	}


	private timer?: number;
	countdown(seconds: number): void {
		if (!this.isRequesting) {
			return;
		}

		this.isRequesting = true;
		this.timer = setInterval(() => {
			seconds -= 1;
			if (seconds > 0) {
				this.getAuthCodeTxt = `${seconds}S`;
			} else {
				clearInterval(this.timer);
				this.isRequesting = false;
				this.getAuthCodeTxt = '请重新获取验证码';
			}
		}, 1000);
	}
	async login() {
		const { phone, code, checkPass } = this.ruleForm;
		const { brandcode } = this.$route.params || {};
		localStorage.setItem('brandcode', brandcode as string);
		this.auth.phone = phone;
		// this.auth.password = "qwer1234";
		this.auth.code = code;
		this.auth.captcha = checkPass;
		this.auth.type = 1;
		this.auth.source = 1;
		this.auth.ka_id = brandcode;

		try {
			const result = await this.authService.login(this.auth, this.$el);
			if (!result) return false;
			this.$message.success('登录成功');
			// 跳转首页
			const shopInfo = await this.shopService.getShopInfo();
			if (shopInfo) {
				this.$router.push('/shop/list');
			} else {
				this.$router.push('/shop/add');
			}
		} catch (error) {
			// console.log(error);
			// this.$message.error(`${error}`);
			this.isRequesting = false;
			this.picker(this.ruleForm.phone);
		}

	}

	submitForm() {
		console.log(this.ruleForm);
		this.ruleRefForm.validate((valid: boolean) => {
			if (valid) {
				console.log('submit');
				this.login();
			} else {
				console.log('error submit!!');
				return false;
			}
		});
	}

	resetForm() {
		console.log(this.ruleForm);
	}
}
</script>
<style scoped lang="scss">
.login {
	width: 100%;
	height: 100%;
	background-color: #fff;

	.login-title {
		width: 100%;
		height: 100px;
		background-color: #fff;
		text-align: center;
		line-height: 100px;
	}

	.login-content {
		width: 100%;
		// height: 100px;
		box-sizing: border-box;
		padding: 20px;
		background-color: #fff;

		.code-box {
			display: flex;
			align-items: center;
		}
	}

	.login-btn {
		width: 100%;
		margin-top: 20px;
	}
}
</style>
